import React from "react";
import { Helmet } from "react-helmet";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import { useTheme } from "@mui/material/styles";
import { Box, Container, CircularProgress, useMediaQuery } from "@mui/material";
import { ModalGenerico } from "../../components/Modals";
import { LogoItalmundo } from "assets";
const baseUrlCanonical = window.baseUrlCanonical;
export const PageContainer = ({
  children,
  loading,
  modal,
  handleModalCloseClick,
  canonicalUrl = "",
  noImage = false,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const helmetURL = `${baseUrlCanonical}${canonicalUrl}`;

  const ImagenCabecera = () => {
    return (
      <div className={classes.contentImageMobile}>
        <img
          src={LogoItalmundo}
          alt="Home Mobile"
          style={{
            width: "50%",
            maxWidth: "250px",
            maxHeight: "100%",
            objectFit: "contain",
            paddingTop: "0.5rem",
            margin: mobile ? "1rem" : "3rem",
          }}
        />
      </div>
    );
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        padding: "0",
        paddingBottom: "1.5rem",
      }}
    >
      {canonicalUrl != "" && (
        <Helmet>
          <link rel="canonical" href={helmetURL} />
        </Helmet>
      )}
      {!noImage && <ImagenCabecera />}
      {children}
      {loading && (
        <Box className={classes.overlay}>
          <CircularProgress sx={{ color: "#C4C4C4" }} />
        </Box>
      )}
      { modal && 
        <ModalGenerico
        modal={modal}
        handleModalCloseClick={() => handleModalCloseClick()}
      /> }
    </Container>
  );
};

export default PageContainer;
